import React from "react";

export const NoDataMessage = () => (
  <p className="text-lg text-red-500 text-center py-4">
    Please set up your settings when you're ready. Click 'Generate
    Calendar' to create new data.
  </p>
);

export const NoMonthSelectedMessage = () => (
  <p className="text-lg text-red-500 text-center px-8 py-4">
    It looks like you have data ready, but you haven't selected a specific
    month yet. When you select the month, make sure to save it by clicking
    the 'Update Month' button or Refresh it.
  </p>
);